import React from "react";
import { Routes, Route } from "react-router-dom";
import { NewAssistancePublic } from "../pages/assistance";
import { AssistanceLayout } from "../layouts/AssistanceLayout";

export function AssistanceRouterPublic() {
  return (
    <Routes>
      <Route path="/" element={<AssistanceLayout />}>
        {/* Ruta con parámetro dinámico :assistantId */}
        <Route path=":assistantId" element={<NewAssistancePublic />} />
      </Route>
    </Routes>
  );
}
